var map = {
	"./alipay.svg": 6485,
	"./amex.svg": 2774,
	"./diners.svg": 7366,
	"./discover.svg": 9667,
	"./elo.svg": 8398,
	"./hiper.svg": 381,
	"./hipercard.svg": 8525,
	"./jcb.svg": 4989,
	"./maestro.svg": 9060,
	"./mastercard.svg": 806,
	"./mir.svg": 5690,
	"./paypal.svg": 6443,
	"./unionpay.svg": 1751,
	"./visa.svg": 1029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4148;